import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react'
import { providerDetails } from "../redux/provider/actions";
import { useDispatch, useSelector } from 'react-redux'
import _ from "lodash"
import { getAllCertifiedNIIT } from "../redux/certified/actions";
import { NavDropdown } from "react-bootstrap";
import BannerSectionProvider from "./BannerSectionProvider";
import {
    SessionKeys,
  } from "../utils/AppUtils";
const MenuCoaching = (props) => {
    const [providerDetailsData, setproviderDetailsData] = useState();
    const [providerImg, setProviderImg] = useState();
    const [providerName, setproviderName] = useState();
    const [certifiedList, setCertifiedList] = useState();
    const [selectedCategory, setselectedCategory] = useState();

    const dispatch = useDispatch();
    let provider_id = props.providerId;
    console.log("props - providerId in menu", props, "-", provider_id);
        useEffect(() => {
          document.body.classList.add('partner-layout')
          return () => {
            document.body.classList.remove('partner-layout')
          }
        }, [])
    useEffect(() => {

        dispatch(providerDetails({
            postData: {
                provider_id: provider_id,
                entity_type: "get_provider_details",
                token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            },
        })
        )
    }, [provider_id]);

    const [loading, setLoading] = useState(false);
    // useEffect(() => {
    // const getCertifications = () => {
    //     dispatch(
    //         getAllCertifiedNIIT({
    //             module: "getAllCertifiedList",
    //             postData: {
    //                 module: "AllCertificate",
    //                 provider_id:provider_id
    //             },
    //         })
    //     );
    //     }
    // }, []);
    // const certifiedData = useSelector((state) => state.certified.allCertified);

    // useEffect(() => {
    //     if (!_.isEmpty(certifiedData) && certifiedData.status === "success") {
    //         if (!_.isEmpty(certifiedData.payload.payload)) {
    //             let certifiedArray = certifiedData.payload.payload;
    //             for (let certify of certifiedArray) {
    //                 certify.source = "xsel";
    //             }
    //             setCertifiedList(certifiedArray);
    //         }
    //     }
    // }, [certifiedData,provider_id]);

    const providersDetailsResponse = useSelector((state) => state.provider.providerDetailsRes);
    console.log("menu coaching", providersDetailsResponse);
    useEffect(() => {
        if (!_.isEmpty(providersDetailsResponse)) {
            if (providersDetailsResponse.status === "success") {
                setproviderDetailsData(providersDetailsResponse.payload.data.menu.filter((item) => item.status === true));
                setProviderImg(providersDetailsResponse.payload.data.provider_img);
                setproviderName(providersDetailsResponse.payload.data.provider_name);
                setselectedCategory(providersDetailsResponse.payload.data.category_id);
            } else {
                setproviderDetailsData();
            }
        }
    }, [providersDetailsResponse]);

    let navigate = useNavigate();
    const [selectedMenuItem, setselectedMenuItem] = useState(props.selectedItem);

    const goToMenu = (menuName, menuId, menuValue) => {
        setselectedMenuItem(menuId);
        console.log("clicked_on", menuValue);
        if (menuId === 0) {
            navigate(`/provider-details-page?provider_id=${provider_id}`)
        }
        else if (menuName === "Courses") {
            navigate(`/provider-course-categories?selectedCategory=${selectedCategory}&provider_id=${provider_id}`, { state: { isLoading: true } });
            //
        }
        else if (menuName === "Videos") {
            navigate(`/provider-video-categories?provider_id=${provider_id}`);
        }
        else if (menuName === "Events") {
            navigate(`/provider-events?source=xsel&provider_id=${provider_id}`)
        }
        // else if(menuName === "Certifications")
        // {
        //    getCertifications();
        // }
        else if (menuName === "Coaching") {
            navigate(`/coaching?provider_id=${provider_id}`, { state: { type: menuValue } })
        }
        // else if(menuName === "Other Services")
        // {
        //     navigate(`/other-services?provider_id=${provider_id}`)
        // }
        else if (menuValue === "marketing" || menuValue === "ai_industry" || menuValue === "mining_farm") {
            navigate(`/other-services?provider_id=${provider_id}`, { state: { type: menuValue, name: menuName } })
        }
    }

    const goToOtherServiceDetail = (item) => {
        navigate(`/other-services?provider_id=${provider_id}`, { state: { type: item.menu_value, name: item.menu_name } })
    };

    return (
        <>
            <div className="coaching-menu-section">
                <div className="container">
                    <nav className="navbar navbar-expand-lg navbar-light justify-content-center">


                        <div className="d-flex justify-content-center navbar-collapse" id="navbarNavAltMarkup">
                            <ul className="navbar-nav">
                                {providerDetailsData ? providerDetailsData.map((item) => (
                                    <li className={selectedMenuItem === item.menu_id ? "nav-item nav-link active" : "nav-item nav-link"} onClick={() => goToMenu(item.menu_name, item.menu_id, item.menu_value)} >{item.menu_id === 0 ? (<span dangerouslySetInnerHTML={{ __html: item.menu_name + " " + providerName }} />)
                                        //    : item.menu_id === 6 ? 
                                        //      item.sub_menu_list.length > 0 ?
                                        //         <NavDropdown title={item.menu_name}>
                                        //             {item.sub_menu_list.map((sub_item, index) => {
                                        //                 return (
                                        //                     sub_item?.status ?
                                        //                     <NavDropdown.Item
                                        //                         onClick={() => goToOtherServiceDetail(sub_item)}
                                        //                         className="dropdownItem_getCertified customHover"
                                        //                         key={`menu-${index + 1}`}
                                        //                     >
                                        //                         {sub_item.menu_name}
                                        //                     </NavDropdown.Item>
                                        //                      : ""
                                        //                 );
                                        //             })}
                                        //         </NavDropdown>
                                        //         : ""
                                        : item.menu_name}</li>
                                )) : ""}
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
            <div className="provider-slider">
                {
                    props.showBanner ?
                    <BannerSectionProvider providerId={provider_id} />
                    : ""
                }
            </div>
        </>
    )
}

export default MenuCoaching;